module.exports = __webpack_public_path__ + "static/media/edit.3b27efdd.svg";